/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SellerOfRecordEnum } from './sellerOfRecordEnum';
import { DataCentersEnum } from './dataCentersEnum';


export interface PaidPilotConfig { 
    dataCenter?: DataCentersEnum;
    /**
     * Subscription/Offer region.
     */
    region?: PaidPilotConfig.RegionEnum;
    seller?: SellerOfRecordEnum;
}
export namespace PaidPilotConfig {
    export type RegionEnum = 'EMEA' | 'APAC' | 'NA';
    export const RegionEnum = {
        EMEA: 'EMEA' as RegionEnum,
        APAC: 'APAC' as RegionEnum,
        NA: 'NA' as RegionEnum
    };
}


